import { Controller } from "@hotwired/stimulus"

// Refreshes the Missions Planning detail modal after a review decision made
// from inside it.
//
// The shared reviews/*.turbo_stream.erb templates replace the mission SHOW
// page's dom_ids (review_status / review_actions), and Review#broadcast_review_update
// targets the card's planning_review_status. None of those are the modal's own
// copies, which are context-namespaced precisely so they can't collide with
// the card sitting behind them -- so without this the modal would keep showing
// the previous decision, and its commentary block would miss the note that was
// just written.
//
// Reloading the frame re-renders the whole modal from the server, so the pill,
// the action buttons and the commentary all end up correct together, rather
// than three separate stream targets that could drift apart. The dialog itself
// is untouched, so the modal does not close.
export default class extends Controller {
  static values = { missionId: Number }

  connect() {
    this.onStream = this.handleStream.bind(this)
    document.addEventListener("turbo:before-stream-render", this.onStream)
  }

  disconnect() {
    document.removeEventListener("turbo:before-stream-render", this.onStream)
  }

  handleStream(event) {
    const target = event.detail?.newStream?.getAttribute("target")
    if (!target) return

    // Any review stream for THIS mission, whichever dom_id convention the
    // shared templates happen to aim at.
    const id = this.missionIdValue
    const isReviewStream = [
      `review_status_mission_${id}`,
      `review_actions_mission_${id}`,
      `planning_review_status_mission_${id}`
    ].includes(target)
    if (!isReviewStream) return

    const frame = document.getElementById("content_modal_frame")
    if (!frame || !frame.src) return

    // After the stream has landed, so the reload reflects the saved decision.
    requestAnimationFrame(() => frame.reload())
  }
}
